/* eslint-disable */
export default {
  _Blobble_Jingle: 'Blobble_Jingle',
  _click: 'click',
  _Create_Blob: 'Create_Blob',
  _error: 'error',
  _good_job: 'good_job',
  _next_level: 'next_level',
  _Push_Blob: 'Push_Blob',
  _Rotate_Blob: 'Rotate_Blob',
}